import type { ReactNode } from 'react';
import { HashRouter } from 'react-router-dom';

/**
 * Wrapper central de providers. Usamos HashRouter para que funcione
 * abriendo el build directamente sin servidor (útil para packaging
 * como PWA o escritorio en el futuro).
 */
export function Providers({ children }: { children: ReactNode }) {
  return <HashRouter>{children}</HashRouter>;
}
